<script>

import ConsentSettingsLink from "./components/ConsentSettingsLink";
import ImageUpload from "./components/ImageUpload";
import AdSelectProductForm from "./components/AdSelectProductForm";
import QuestionsToggle from "./components/QuestionsToggle";
import BookmarkToggle from "@/components/BookmarkToggle";
import RangeSlider from "./components/RangeSlider";
import AdFilterInput from "@/components/AdFilterInput";
import AdFilter from "@/components/AdFilter";
import AdFilters from "@/components/AdFilters";
import AddressSelection from "@/components/AddressSelection";
import Autocomplete from "@/components/Autocomplete";
import IdentityDocumentUpload from "@/components/IdentityDocumentUpload";
import PhoneNumberInput from "@/components/PhoneNumberInput";
import ProductAutocomplete from "@/components/ProductAutocomplete";
import Sidebar from "@/components/Sidebar";
import Sentry from "@/components/Sentry";
import AdForm from "./components/AdForm";
import RenewAd from "./components/Ads/RenewAd";
import CreateAd from "./components/Ads/CreateAd";
import EditAd from "./components/Ads/EditAd";
import ReconditionAd from "./components/Ads/ReconditionAd.vue";

export default {
    name: 'App',
    components: {
        BookmarkToggle,
        ConsentSettingsLink,
        ImageUpload,
        AdSelectProductForm,
        RangeSlider,
        AdFilterInput,
        AdFilter,
        AdFilters,
        QuestionsToggle,
        AddressSelection,
        Autocomplete,
        IdentityDocumentUpload,
        PhoneNumberInput,
        ProductAutocomplete,
        Sidebar,
        AdForm,
        RenewAd,
        ReconditionAd,
        EditAd,
        CreateAd,
        Sentry
    },
}
</script>

<style>
</style>
